import {merge} from 'lodash';

import Assessment from '../assessment';
import AssessmentResult from '../../../values/AssessmentResult';
import {CHARACTERS_URL, URLS_POINTS} from '@axyseo/const/analysis';
import {enhanceResearcherForChinese} from '@axyseo/languageProcessing/helpers/language/chineseHelperFactory';

/**
 * Represents the Slug keyword assessment. This assessment checks if the keyword is present in the slug.
 */
class InvalidCharactersInUrl extends Assessment {
  /**
   * Sets the identifier and the config.
   *
   * @param {Object} config   The configuration to use.
   * @returns {void}
   */
  constructor(config = {}) {
    super();

    const defaultConfig = {
      id: CHARACTERS_URL,
      docUrl:
        'https://docs.avada.io/seo-suite-help-center/seo-audit/on-page-seo/checklist#keyword-in-url',
      fixPosition: 'url handle',
      ctaType: 'fix',
      priority: 'medium',
      title: 'Invalid characters in URL',
      content: {
        good: 'URL characters valid',
        improve: '',
        bad: 'Use only lowercase letters, numbers, and hyphens.'
      }
    };

    this.identifier = CHARACTERS_URL;
    this._config = merge(defaultConfig, config);
  }

  /**
   * Executes the Assessment and returns a result.
   *
   * @param {Paper}       paper       The Paper object to assess.
   * @param {Researcher}  researcher  The Researcher object containing all available researches.
   *
   * @returns {AssessmentResult} The result of the assessment, containing both a score and a descriptive text.
   */
  getResult({paper, researcher}) {
    // Enhance researcher for Chinese if needed - specifically for URL context
    const enhancedResearcher = enhanceResearcherForChinese(
      researcher,
      paper.getSlug(),
      paper.getKeyword(),
      true // isUrlContext = true for enhanced Chinese URL matching
    );

    this._charactersInUrl = enhancedResearcher.getResearch('charactersInUrl');
    const assessmentResult = new AssessmentResult({config: this._config});

    const calculatedResult = this.calculateResult();

    assessmentResult.setScore(calculatedResult.score);
    assessmentResult.setStatus(calculatedResult.status);
    return assessmentResult;
  }

  /**
   * Checks whether the paper has a keyword and a slug.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   * @param {Researcher}  researcher  The researcher object.
   *
   * @returns {boolean} True if the paper contains a keyword and a slug, and if the keywordCountInSlug research is available on the researcher.
   */
  isApplicable(paper, researcher) {
    return true;
  }

  /**
   *
   * @returns {{score: number, status: (string)}}
   */
  calculateResult() {
    const status = this?._charactersInUrl?.isInvalidCharacters ? 'bad' : 'good'
    const score = this.getScore(URLS_POINTS , status);

    return {
      score,
      status
    };
  }
}

export default InvalidCharactersInUrl;
